/**
 * `?cage=0` is a debugging aid that bypasses the clothing skin cage entirely (no panels are registered, so nothing is solved, uploaded or
 * bound; cloth hangs from its skinning and the leg push alone). It holds for the rest of this tab's visit, reloads included; `?cage=1`
 * turns it back on. Read when a figure is built, so reload after changing it.
 */
const KEY = 'nimblez.cage';

function requested(): boolean {
  if (typeof location === 'undefined') return true;
  const value = new URLSearchParams(location.search).get('cage');
  try {
    if (value !== null) value === '0' ? sessionStorage.setItem(KEY, '0') : sessionStorage.removeItem(KEY);
    return sessionStorage.getItem(KEY) !== '0';
  } catch { return value !== '0'; }
}

export const clothCageEnabled = requested();
